// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"281":"10758f18","402":"982e8b1e","423":"6de0c9d7","513":"0ad9a53d","542":"25c0468b","623":"96801b21","787":"4ada8902","923":"80c82a89","925":"78fc7380","951":"9450e7a3"}[chunkId] + ".chunk.js";
};